import axios from 'axios';

// Configuración base de Axios
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  timeout: 30000, // 10 segundos de timeout
});

// Interceptor para agregar el token de autenticación
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas y errores
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.code === 'ECONNREFUSED') {
      error.userMessage = 'No se puede conectar al servidor. Verifica que Laravel esté corriendo.';
    } else if (error.response?.status === 404) {
      error.userMessage = 'Ruta de API no encontrada. Verifica la configuración del backend.';
    } else if (error.response?.status === 401) {
      // Token expirado o no válido
      // Solo limpiar y redirigir si NO es SSO (para evitar borrar token SSO válido)
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      
      if (user.origen === 'cip') {
        // Si es usuario de CIP, mostrar alerta pero no borrar ni redirigir
        error.userMessage = 'Error de autenticación SSO. Por favor, recarga la página.';
      } else {
        // Usuario normal, limpiar y redirigir
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;